export default __webpack_public_path__ + "cd66b8f63f6566194c7ed597586ec3bf.png";